/**


{
  scFindCredentials
  {
    credentials {
      id
      key
    }
  }
}




{
  scFindCredentials(key: "sap_order_products")
  {
    credentials {
      id
      key
      data {
        key
        value
        type
      }
    }
  }
}


 */
import { gql } from 'graphql-request';
import { client } from '@/graph/client';
import { listCredentials } from './types/listCredentials';
import { KeyValuePair } from '@/graph/types/global';
import { createCredential } from './types/createCredential';
import { updateCredential } from './types/updateCredential';
// import { listPermissions } from './types/permissionsList';

export type CredentialsList = {
	id: string,
	key: string,
}

export type Credential = CredentialsList & {
	data?: KeyValuePair[],
}

class Credentials
{
	public async list(): Promise<CredentialsList[]>
	{
		const out:CredentialsList[] = [];

		const query = gql`
			{
				scFindCredentials
        {
          credentials {
            id
            key
          }
        }
			}
		`;

		const response = await client.request<listCredentials>(query);

		console.log("Graph.Servicecloud.Credentials.list", response);

		if(response.scFindCredentials.credentials)
		{
			for(const cred of response.scFindCredentials.credentials)
			{
				if(cred.id && cred.key)
				{
					out.push({
						id: cred.id ?? "",
						key: cred.key ?? "",
					});
				}
			}
		}

		return out;
	}

	public async get(credentialskey: string): Promise<Credential[]>
	{
		const out:Credential[] = [];

		const query = gql`
			{
        scFindCredentials(key: "` + credentialskey + `")
        {
          credentials {
            id
            key
            data {
              key
              value
              type
            }
          }
        }
			}
		`;

		const response = await client.request<listCredentials>(query);

		console.log("Graph.Servicecloud.Credentials.get", response);

		if(response.scFindCredentials.credentials)
		{
			for(const cred of response.scFindCredentials.credentials)
			{
				if(cred.id && cred.key)
				{
					out.push({
						id: cred.id,
						key: cred.key ?? "",
						data: cred.data ?? [],
					});
				}
			}
		}

		return out;
	}

	public async createCredential(key: string): Promise<{ id: string, success: boolean }>
	{
		const query = gql`
			mutation createCredential($key: String!)
			{
				scCreateCredential(key: $key)
				{
					success
					id
				}
			}
		`;

		const response = await client.request<createCredential>(query, { key });

		console.log("Users.createCredential", response);

		return {
			id: response.scCreateCredential.id,
			success: response.scCreateCredential.success,
		};
	}

	public async updateCredential(key: string, data: KeyValuePair[]): Promise<{ id: string, success: boolean }>
	{
		const query = gql`
			mutation updateCredential($key: String!, $data: [KeyValue])
			{
				scUpdateCredential(
					key: $key
					data: $data
				)
				{
					success
					id
				}
			}
		`;

		const response = await client.request<updateCredential>(query, { key, data });

		console.log("Users.updateCredential", response);

		return {
			id: response.scUpdateCredential.id,
			success: response.scUpdateCredential.success,
		};
	}
}

export default new Credentials();